export default __webpack_public_path__ + "static/media/Flag of Andorra.e0d23ca0.gif";